//
//
//
//


export default {
  props: {
    overlay: {
      type: String,
      required: false,
      default: ''
    }
  }
}
